import { Box } from '@mui/material';
import Link from '@mui/material/Link';
import type { ReactNode } from 'react';

type Props = {
  to?: string;
  children: ReactNode;
};
const BreadcrumbLink = ({ to, children }: Props) => {
  const truncateSx = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: { xs: '160px', sm: '260px', md: 'none' },
    display: 'block'
  };

  return to !== undefined ? (
    <Link sx={{ textDecoration: 'none', ...truncateSx }} href={to}>
      {children}
    </Link>
  ) : (
    <Box sx={{ fontWeight: '400', ...truncateSx }}>{children}</Box>
  );
};

export default BreadcrumbLink;
